import { Modal, Input } from '@salecycle/ui-component-library';
import * as React from 'react';
import { IOffsiteCampaign } from '../../entities/offsiteCampaign';
import * as RestApi from 'core/network/RestApi';
import { useMutation } from 'react-query';
import {
  useOffsiteCampaignsListDispatch,
  useOffsiteCampaignsListState,
} from '../context/UseOffsiteCampaignsListContext';
import { RestApiError } from 'core/network/RestApi';
import useNotifications from 'core/notifications/useNotifications';
import { useParams } from 'react-router-dom';
import { cloneCampaign } from '../../utils/helper';
import { OffsiteCampaignEndpoints } from 'sections/offsite-campaigns/constants/api-endpoints';
import { generatePath } from 'react-router';

export const OffsiteCloneModal: React.FC = () => {
  const [name, setName] = React.useState('');
  const { siteId } = useParams<{ siteId: string }>();
  const dispatch = useOffsiteCampaignsListDispatch();
  const { showNotification } = useNotifications();
  const { campaign } = useOffsiteCampaignsListState();

  const cloneCampaignMutation = useMutation((campaign: IOffsiteCampaign) =>
    RestApi.post<IOffsiteCampaign, IOffsiteCampaign>(
      generatePath(OffsiteCampaignEndpoints.OFFSITE_POST, { siteId }),
      campaign,
    ),
  );

  const handleCloneCampaign = async () => {
    closeModal();
    const result = await RestApi.get<IOffsiteCampaign>(
      generatePath(OffsiteCampaignEndpoints.OFFSITE_GET_BY_ID, { siteId, campaignId: campaign.id }),
    );
    const clone = cloneCampaign(result.data, name);
    cloneCampaignMutation.mutate(clone, {
      onSuccess: data => {
        showNotification(`Clone Successful`, 'normal');
        dispatch({
          type: 'ADD_CAMPAIGN',
          payload: { campaign: data.data },
        });
      },
      onError: (error: RestApiError, variables, context) => {
        showNotification(`Unable to Clone Campaign`, 'error');
      },
    });
  };

  const closeModal = () => {
    dispatch({
      type: 'CLOSE_CLONE_MODAL',
    });
  };

  return (
    <Modal
      isOpen={true}
      heading="Clone a Campaign"
      onOkButtonClicked={handleCloneCampaign}
      okButtonLabel="Save"
      okButtonDisabled={!name}
      onCancelButtonClicked={closeModal}
      cancelButtonLabel="Discard"
    >
      <Input label="Campaign to Clone" ariaLabel="Campaign to Clone" disabled={true} value={campaign.name} />

      <Input
        label="Name"
        ariaLabel="Campaign Name"
        required={true}
        value={name}
        placeholder="Please enter a name for your new campaign"
        onChange={value => setName(value || '')}
      />
    </Modal>
  );
};

export default OffsiteCloneModal;
